export const labelTheme = {
   light: {
      color: 'text-gray-700'
   },
   dark: {}
}
